import { View } from "react-native";
import photo_collage from "src/assets/images/search/photo_collage.png";
import native from "src/constants/native";
import { paddingSpacer, paddingXL } from "src/styles/spacing";
import { Image, Text } from "src/swsh-native";

const aspectRatio = 691 / 791;
const HasKeyboardAdjustment = native;
const SearchEmptyNoSearch = () => {
	return (
		<View
			style={{
				flex: 1,
				alignItems: "center",
				paddingTop: HasKeyboardAdjustment ? paddingXL : paddingSpacer,
			}}
		>
			<Image
				alt="Empty Search Results"
				src={photo_collage}
				dim={{
					aspectRatio,
					height: HasKeyboardAdjustment ? 240 : 300,
				}}
			/>
			<Text
				style={{
					marginTop: paddingXL,
					marginHorizontal: paddingSpacer,
					textAlign: "center",
					lineHeight: 24,
				}}
			>
				Search for albums, groups, or paste an invite link to join
			</Text>
		</View>
	);
};
export default SearchEmptyNoSearch;
